import { render } from "./BatchRefundModal.vue?vue&type=template&id=4be4bb9c&scoped=true&ts=true"
import script from "./BatchRefundModal.vue?vue&type=script&lang=ts"
export * from "./BatchRefundModal.vue?vue&type=script&lang=ts"

import "./BatchRefundModal.vue?vue&type=style&index=0&id=4be4bb9c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be4bb9c"]])

export default __exports__